import type { ReactNode } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@reach/accordion';
import '@reach/accordion/styles.css';
import styled from 'styled-components';

// reset default styles
const StyledAccordionButton = styled(AccordionButton)`
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
`;

const StyledAccordion = styled(Accordion)`
  font-family: inherit;
`;

const StyledAccordionItem = styled(AccordionItem)`
  font-family: inherit;
`;

const StyledAccordionPanel = styled(AccordionPanel)`
  font-family: inherit;
`;

export interface ReachAccordionProps {
  children?: ReactNode;
  index?: number;
  collapsible?: boolean;
  multiple?: boolean;
  onChange?: (index?: number) => void;
  className?: string;
  defaultIndex?: number;
}

const ReachAccordionPrimitive = {
  Root: ({
    children,
    index,
    collapsible,
    multiple,
    onChange,
    className,
    defaultIndex,
  }: ReachAccordionProps) => (
    <StyledAccordion
      index={index}
      collapsible={collapsible}
      multiple={multiple}
      onChange={onChange}
      className={className}
      defaultIndex={defaultIndex}
    >
      {children}
    </StyledAccordion>
  ),
  Item: ({
    children,
    className,
  }: {
    children: ReactNode;
    className?: string;
  }) => (
    <StyledAccordionItem className={className}>{children}</StyledAccordionItem>
  ),
  Button: ({
    children,
    className,
  }: {
    children: ReactNode;
    className?: string;
  }) => (
    <StyledAccordionButton className={className}>
      {children}
    </StyledAccordionButton>
  ),
  Panel: ({
    children,
    className,
  }: {
    children: ReactNode;
    className?: string;
  }) => (
    <StyledAccordionPanel className={className}>
      {children}
    </StyledAccordionPanel>
  ),
};

export default ReachAccordionPrimitive;
